<template>
  <div  :style="gridItemStyle">
    <div ref="self">
      <slot class="h-100" ></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: "DdGridItem",
  data() {
    return {
      colSpan: 1,
      rowSpan: 1,
    }
  },
  props: {
    row:{
      type: [Number, String],
      default: 'auto'
    },
    col:{
      type: [Number, String],
      default: 'auto'
    },
    colSpanProp: {
      type: Number,
      default: () => 1,
    },
    rowSpanProp: {
      type: Number,
      default: () => 1,
    },
  },
  mounted() {
    if (this.colSpanProp) this.colSpan = this.colSpanProp;
    if (this.rowSpanProp) this.rowSpan = this.rowSpanProp;
    this.stretchToContainer();
    let observer = new ResizeObserver(() => this.onResize());
    observer.observe(this.$refs.self);
  },
  methods: {
    onResize() {
      this.unstretchContainer();
      this.stretchToContainer();
    },
    stretchToContainer() {
      this.$refs.self.style.height = '100%';
      this.$refs.self.childNodes[0].style.height = '100%';
    },
    unstretchContainer() {
      this.$refs.self.style.height = 'auto';
      this.$refs.self.childNodes[0].style.height = 'auto';
    }
  },
  computed: {
    gridItemStyle() {
      return {
        gridRow: this.row + ' / span ' + this.rowSpan,
        gridColumn: this.col + ' / span ' + this.colSpan,
      };
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

</style>